import { APP_CONFIG, Env } from '../../environment';
import { regions } from '../../environment/region/regions';

// Automation hook (non-PROD, read at startup): pin the pre-login country instead of the geo-IP one
// that authorization/session/v2 derives from the device's IP address.
//   Native (Appium/Mobilewright in the WebView):  localStorage.setItem('automationCountry', 'US'); then relaunch.
//   Browser convenience:                          ?automationCountry=US anywhere in the URL.
// Values: the 2-letter code of a known region (case-insensitive; GB is read as UK, like getSessionCountryFromToken).
// Returns the upper-case code, or null when unset, invalid or on PROD, so the geo-IP country stays.
// No provider imports here: HttpProvider and UtilsProvider both use it, and UtilsProvider injects HttpProvider.
export function readAutomationCountryOverride(): string | null {
  try {
    if (APP_CONFIG.env === Env.PROD || typeof window === 'undefined') {
      return null;
    }
    const stored = window.localStorage ? parseCountry(window.localStorage.getItem('automationCountry')) : null;
    if (stored !== null) {
      return stored;
    }
    const match = window.location ? (window.location.href || '').match(/[?&]automationCountry=([^&#]+)/) : null;
    return match ? parseCountry(decodeURIComponent(match[1])) : null;
  } catch (ex) {
    return null;
  }
}

function parseCountry(raw: string | null): string | null {
  let value = raw ? raw.toUpperCase() : null;
  if (value === 'GB') {
    value = 'UK';
  }
  // regions is keyed by each region's defaultCountryFrom (the code updateAuthCountry matches on).
  const known = !!value && /^[A-Z]{2}$/.test(value) && Object.prototype.hasOwnProperty.call(regions, value);
  return known ? value : null;
}



// WEBPACK FOOTER //
// ./src/providers/myria/automation-country.ts